import { DO_NOT_USE_FaWrapper } from '../../foundation/falcon/do-not-use-fa-wrapper/index.js';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import { Container, PaginationArrowButton } from './styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function Pagination(props) {
  var children = props.children,
    prev = props.prev,
    next = props.next;
  return /*#__PURE__*/jsxs(Container, {
    children: [/*#__PURE__*/jsx(PaginationArrowButton, {
      disabled: !prev,
      onClick: prev,
      children: /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, {
        icon: faChevronLeft,
        $size: 12
      })
    }), children, /*#__PURE__*/jsx(PaginationArrowButton, {
      disabled: !next,
      onClick: next,
      children: /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, {
        icon: faChevronRight,
        $size: 12
      })
    })]
  });
}

export { Pagination };
